// extracted by css-extract-rspack-plugin
export default {"actionColumn":"mRgGj"};